import { red } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core";
import React, {useRef} from "react";
import "./ToggleBtn.css";


function ToggleBtn3({
  styleType,
  label,
  handleToggleRef,
  toggleState,
  field,
  backgroundStyle,
  externalStyling,
  handleCaching,
  index,
}) {

  const tglRef = useRef(null);

  return (
    <div
      className={
        "toggleBtn" + " " + (externalStyling ? externalStyling.toggle : "")+" control-class"
      }
    >
      <span>{label}</span>
      <div className="slideBar">
        <label
        aria-label="Toggle Button"
          className={
            "switch" + " " + (externalStyling ? externalStyling.center : "")
          }
        >
          {((toggleState+"") === "true") ? (
            <input
              aria-label={"Show Progress"}
              ref={tglRef}
              type="checkbox"
              defaultChecked="true"
              name="showProgress"
              onClick={(e) => {
                handleToggleRef && handleToggleRef(tglRef, field);
                handleCaching && handleCaching(index);
              }}
              value="false"
            />
          ) : (
            <input
              aria-label={"Show Progress2"}
              ref={tglRef}
              type="checkbox"
              name="showProgress"
              value={"true"}
              onClick={(e) => {
                handleToggleRef && handleToggleRef(tglRef, field);
                handleCaching && handleCaching(index);
              }}
            />
          )}
          <span
            className={
              styleType === "2"
                ? "slider2 slider round"
                : "slider round" +
                  " " +
                  (externalStyling ? externalStyling.input : "")
            }
            onClick={(e) => {
            }}
            style={backgroundStyle}
          ></span>
          {styleType === "3" && <span className="sliderText"></span>}
        </label>
      </div>
    </div>
  );
}

export default ToggleBtn3;
